import {useId} from 'react';
import type {Snapshot} from '@platform/contracts/x';
import {LiveScene} from './RoomLive';
import {RoomControls} from './RoomControls';

// Reuse the room scene with purchase draw overlays and the current broadcast.
// The underlying room remains the only owner of number speech.
export function PurchaseScene({state,live,broadcast,sound,onBroadcast,onSound}:{state:Snapshot;live:Snapshot;broadcast:boolean;sound:boolean;onBroadcast:()=>void;onSound:(value:boolean)=>void}){
 const mediaId=useId();
 return <LiveScene compact state={state} mediaState={live} mediaId={mediaId} broadcast={broadcast} sound={false} onSoundChange={onSound} controls={<RoomControls mediaId={mediaId} broadcast={broadcast} onBroadcast={onBroadcast} sound={sound} onSound={()=>onSound(!sound)}/>}/>;
}
